module.exports = __webpack_public_path__ + "img/checked-partial.477d637e.svg";